
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const HeaderLogoSize = {
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
  XLarge: 'XLarge'
} as const

export type HeaderLogoSize = (typeof HeaderLogoSize)[keyof typeof HeaderLogoSize]


export const PageKind = {
  Page: 'Page',
  Post: 'Post'
} as const

export type PageKind = (typeof PageKind)[keyof typeof PageKind]


export const FormActionKind = {
  Email: 'Email',
  Webhook: 'Webhook',
  AgencyZoom: 'AgencyZoom',
  AgencyMvp: 'AgencyMvp',
  HighLevel: 'HighLevel',
  Ricochet360: 'Ricochet360'
} as const

export type FormActionKind = (typeof FormActionKind)[keyof typeof FormActionKind]


export const WebContentFetchStatus = {
  Queued: 'Queued',
  Starting: 'Starting',
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed',
  Canceled: 'Canceled',
  Expired: 'Expired'
} as const

export type WebContentFetchStatus = (typeof WebContentFetchStatus)[keyof typeof WebContentFetchStatus]


export const ActorType = {
  User: 'User',
  BlogAutomation: 'BlogAutomation'
} as const

export type ActorType = (typeof ActorType)[keyof typeof ActorType]


export const ServiceStatus = {
  Inactive: 'Inactive',
  Pending: 'Pending',
  Trial: 'Trial',
  Paid: 'Paid',
  Transferred: 'Transferred'
} as const

export type ServiceStatus = (typeof ServiceStatus)[keyof typeof ServiceStatus]


export const SubscriptionStatus = {
  Incomplete: 'Incomplete',
  IncompleteExpired: 'IncompleteExpired',
  Trialing: 'Trialing',
  Active: 'Active',
  PastDue: 'PastDue',
  Canceled: 'Canceled',
  Unpaid: 'Unpaid',
  Paused: 'Paused'
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]


export const RunStatus = {
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed',
  Canceled: 'Canceled'
} as const

export type RunStatus = (typeof RunStatus)[keyof typeof RunStatus]


export const DomainStatus = {
  Pending: 'Pending',
  DnsPending: 'DnsPending',
  Provisioning: 'Provisioning',
  Active: 'Active',
  Error: 'Error'
} as const

export type DomainStatus = (typeof DomainStatus)[keyof typeof DomainStatus]


export const ReadinessStatus = {
  Queued: 'Queued',
  Running: 'Running',
  Completed: 'Completed',
  NotFound: 'NotFound',
  Failed: 'Failed'
} as const

export type ReadinessStatus = (typeof ReadinessStatus)[keyof typeof ReadinessStatus]


export const ReadinessProvider = {
  IsItAgentReady: 'IsItAgentReady',
  IsAgentic: 'IsAgentic'
} as const

export type ReadinessProvider = (typeof ReadinessProvider)[keyof typeof ReadinessProvider]


export const BillingRequestKind = {
  Setup: 'Setup',
  Activate: 'Activate',
  Cancel: 'Cancel',
  Restore: 'Restore',
  RenewTransfer: 'RenewTransfer',
  ActivateTransfer: 'ActivateTransfer'
} as const

export type BillingRequestKind = (typeof BillingRequestKind)[keyof typeof BillingRequestKind]


export const BillingService = {
  Website: 'Website',
  BlogAutomation: 'BlogAutomation'
} as const

export type BillingService = (typeof BillingService)[keyof typeof BillingService]


export const BillingRequestStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  AwaitingPaymentMethod: 'AwaitingPaymentMethod',
  AwaitingPayment: 'AwaitingPayment',
  Committing: 'Committing',
  Applied: 'Applied',
  Failed: 'Failed',
  Canceled: 'Canceled',
  Scheduled: 'Scheduled',
  Reversed: 'Reversed'
} as const

export type BillingRequestStatus = (typeof BillingRequestStatus)[keyof typeof BillingRequestStatus]


export const TransferStatus = {
  Failed: 'Failed',
  Pending: 'Pending',
  Preparing: 'Preparing',
  AwaitingPaymentMethod: 'AwaitingPaymentMethod',
  AwaitingPayment: 'AwaitingPayment',
  Committing: 'Committing',
  Accepted: 'Accepted',
  Canceled: 'Canceled',
  Expired: 'Expired'
} as const

export type TransferStatus = (typeof TransferStatus)[keyof typeof TransferStatus]


export const TransferCoverage = {
  Free: 'Free',
  Activation: 'Activation',
  Prepaid: 'Prepaid'
} as const

export type TransferCoverage = (typeof TransferCoverage)[keyof typeof TransferCoverage]


export const DeliveryStatus = {
  Pending: 'Pending',
  Queued: 'Queued',
  Sending: 'Sending',
  Delivered: 'Delivered',
  Suppressed: 'Suppressed',
  Uncertain: 'Uncertain',
  Failed: 'Failed'
} as const

export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus]


export const QualityCheckStatus = {
  Queued: 'Queued',
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed'
} as const

export type QualityCheckStatus = (typeof QualityCheckStatus)[keyof typeof QualityCheckStatus]


export const NeutralColorPreset = {
  Gray: 'Gray',
  GreenGray: 'GreenGray',
  BlueGray: 'BlueGray',
  GoldGray: 'GoldGray'
} as const

export type NeutralColorPreset = (typeof NeutralColorPreset)[keyof typeof NeutralColorPreset]


export const SuperGrantType = {
  Bearer: 'Bearer',
  OAuth: 'OAuth'
} as const

export type SuperGrantType = (typeof SuperGrantType)[keyof typeof SuperGrantType]
